import type { DialoguePool } from '@/state/types';

export const L17_DIALOGUE: DialoguePool = {
  slowPlay: [
    'The tea is getting cold. The biscuit is getting nervous.',
    '2.4 seconds. Not 2.3. Not 2.5. A FEEB with a stopwatch could manage it.',
    'The digestives are watching. Waiting. Judging.',
  ],
  tokenLoss: [
    'Soggy! You\u2019ve ruined the dignity of the digestives!',
    'Dry. Uncivilised. Your ancestors weep into their cuppas.',
    'Broken. Like a promise. Like a teacup. Like you.',
  ],
  solution: [
    'Two point four seconds. Precisely. I\u2019m almost proud. Almost.',
    'Golden. The biscuit yields. The tea approves. The bunker exhales.',
    'A perfect dunk. Don\u2019t get cocky, FEEB. The next one will break.',
  ],
  spite: ['Two point four. Again. Do it. I dare you to get it wrong this time.'],
};
